import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  LocationStrategy,
  HashLocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

// import { Ng2TableModule } from 'ngx-datatable/ng2-table'

const APP_CONTAINERS = [DefaultLayoutComponent];

// import {
//   AppAsideModule,
//   AppBreadcrumbModule,
//   AppHeaderModule,
//   AppFooterModule,
//   AppSidebarModule,
// } from '../../dist/@coreui/angular';

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';
// Import routing module
import { AppRoutingModule } from './app.routing';

import { LogInComponent } from './views/log-in/log-in.component';
import { HttpClientModule } from '@angular/common/http';
import {
  DlDateTimeDateModule,
  DlDateTimePickerModule,
} from 'angular-bootstrap-datetimepicker';
import { OccupancyTableComponent } from './views/occupancy-table/occupancy-table.component';

import { GlimpseLayoutComponent } from './containers/glimpse-layout/glimpse-layout.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavItemComponent } from './containers/glimpse-layout/components/nav-item/nav-item.component';
import { ProfileComponent } from './containers/glimpse-layout/components/profile/profile.component';
import { NavItemModule } from './containers/glimpse-layout/components/nav-item/nav-item.module';
import { ProfileModule } from './containers/glimpse-layout/components/profile/profile.module';

import { MatIconModule } from '@angular/material/icon';
import { NavListComponent } from './containers/glimpse-layout/components/nav-list/nav-list.component';
import { MatDividerModule } from '@angular/material/divider';
import { SelectModule } from './components/select/select.module';
import { SelectDateModule } from './components/select-date/select-date.module';
import { MatButtonModule } from '@angular/material/button';
import { GateDataBranchComponent } from './components/gate-data-branch/gate-data-branch.component';
import { OAuthComponent } from './views/o-auth/o-auth.component';
import { ResetPasswordSessionComponent } from './password-reset-components/reset-password-session/reset-password-session.component';
import { VerifyOtpComponent } from './password-reset-components/verify-otp/verify-otp.component';
import { ResetOldPasswordComponent } from './password-reset-components/reset-old-password/reset-old-password.component';
import { StoreSelectionComponent } from './views/store-selection/store-selection.component';
import { MergedButtonsModule } from './components/merged-buttons/merged-buttons.module';
import { CameraPreviewModule } from './components/camera-preview/camera-preview.module';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DlDateTimeDateModule,
    DlDateTimePickerModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    BsDropdownModule.forRoot(),
    SelectModule,
    SelectDateModule,
    MatButtonModule,
    MatTooltipModule,
    MergedButtonsModule,
    CameraPreviewModule,
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LogInComponent,
    OccupancyTableComponent,
    GlimpseLayoutComponent,
    NavItemComponent,
    ProfileComponent,
    NavListComponent,
    GateDataBranchComponent,
    OAuthComponent,
    ResetPasswordSessionComponent,
    VerifyOtpComponent,
    ResetOldPasswordComponent,
    StoreSelectionComponent,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
